import { getUserId } from '@/utils/auth';
import request from '@/utils/request';

// 解析 token & 用户ID
const token = localStorage.getItem('infoToken') || '';
const userId = getUserId(token);

const state = {
  userid: userId,
};

const mutations = {
  // SET_TOKEN: (state, token) => {
  //   state.token = token;
  // },
};

const actions = {
  /**
   * 读取新闻列表
   * @param {Object} data 接口参数 { url }
   */
  async newlist(_, data) {
    try {
      const res = await request({
        url: '/admin/new/list',
        method: 'post',
        data,
      });
      return res;
    } catch (err) {
      console.error('读取新闻失败：', err);
      throw err;
    }
  },

  /**
   * 批量删除新闻列表
   * @param {Object} data 接口参数 { url }
   */
  async dele_NewList(_, data) {
    try {
      const res = await request({
        url: '/admin/new/delete',
        method: 'post',
        data,
      });
      return res;
    } catch (err) {
      console.error('删除失败：', err);
      throw err;
    }
  },

  /**
   * 删除上传文件/图片
   * @param {Object} data 接口参数 { url }
   */
  async deletUpload(_, data) {
    try {
      const res = await request({
        url: '/admin/upload/new/delete',
        method: 'post',
        data,
      });
      return res;
    } catch (err) {
      console.error('删除文件接口请求失败：', err);
      throw err;
    }
  },
  /**
   * 新增新闻及文件/图片
   * @param {Object} data 接口参数 {  }，对象
   */
  async submitUpload(_, data) {
    try {
      const res = await request({
        url: '/admin/upload/submitNewUpload',
        method: 'post',
        data,
      });
      return res;
    } catch (err) {
      console.error('新增新闻失败：', err);
      throw err;
    }
  },
};

const getters = {
  userid: (state) => state.userid,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
